import { type DateRange } from 'react-day-picker';

import { dateRangeDefaultValue } from '@/components/Popover';
import { parseRangeDateFromUrl, serializeRangeDateToUrl } from '@/utils/date';
import { parseAsJson, useQueryState } from '@/utils/useQueryState';

export const useDateRangeQueryState = () => {
  return useQueryState<DateRange>(
    'date',
    parseAsJson<DateRange>(parseRangeDateFromUrl, serializeRangeDateToUrl)
      .withDefault(dateRangeDefaultValue)
      .withOptions({ clearOnDefault: true })
  );
};
